import { C, SectionLabel, H2, BtnNavy, wrap, useIsMobile } from '../styles';

const points = [
  { t: 'Organized briefs only', b: 'Every project arrives with a structured brief, concept visual, and client-approved specifications.' },
  { t: 'Pre-qualified clients', b: 'We confirm intent and budget before a brief reaches your inbox.' },
  { t: 'No exclusivity required', b: 'Participate without committing to volume minimums or exclusivity clauses.' },
  { t: 'No cost to join', b: 'No subscription and no upfront cost to participate. Take on the work that fits your shop.' },
];

export default function Manufacturers() {
  const isMobile = useIsMobile();
  return (
    <section id="manufacturers" style={{ padding: isMobile ? '64px 0' : '88px 0', borderTop: `1px solid ${C.bdr}` }}>
      <div style={wrap}>
        <div style={{
          background: C.surf, border: `1px solid ${C.bdr}`, borderRadius: 12,
          padding: isMobile ? 24 : 56, display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
          gap: isMobile ? 28 : 52, alignItems: 'center',
        }}>
          <div>
            <SectionLabel>For manufacturers</SectionLabel>
            <H2 style={{ marginBottom: 16 }}>Receive structured, qualified leads.</H2>
            <p style={{ color: C.mut, fontSize: 15, lineHeight: 1.75, marginBottom: 26 }}>
              MetalMatch delivers pre-screened fabrication requests as organized briefs — complete with drawings, specifications, quantity, and timeline. No chasing vague inquiries. Every lead that reaches you is ready to quote.
            </p>
            <BtnNavy>Apply to Join the Network →</BtnNavy>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {points.map(({ t, b }) => (
              <div key={t} style={{ background: C.surf2, border: `1px solid ${C.bdr}`, borderRadius: 8, padding: '14px 18px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: C.navy, flexShrink: 0, marginTop: 6 }} />
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: C.txt, marginBottom: 2 }}>{t}</div>
                  <p style={{ fontSize: 12, color: C.mut, lineHeight: 1.6 }}>{b}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
